import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './Newfundoffer.css';
import { format, parseISO } from 'date-fns';
import Pagination from '../../CommonUI/Pagination/Pagination';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'

function Newfundoffer() {
    const [data, setData] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("equity");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrl = BaseURL + "MfNewFundOffer";
        if (groupValue === "equity") {
            // alert(`${getUrl}/NFO/${groupValue}/-`)
            fetch(`${getUrl}/NFO/${groupValue}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });

        } else {
            // const getUrl = BaseURL + "MfNewFundOffer";
            // alert(`${getUrl}/NFO/${groupValue}/-`)
            fetch(`${getUrl}/NFO/${groupValue}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);

                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                setloadingshow(false);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue]);

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    const routeChange = (paramname) => {
        window.open("/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', ''), "_blank");
    }

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>New Fund Offer</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Newfund-loser-sc'>
                            <div className='Newfund-header'>
                                <h2><span>New Fund Offer</span></h2>
                            </div>
                            <MarketMF optionValue="New Fund Offer" />

                            <div className='Newfund-right'>
                                <div className='Newfund-inner-select'>
                                    <select onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="equity" selected="equity">Equity</option>
                                        <option value="Debt">Debt</option>
                                        <option value="hybrid">Hybrid</option>
                                    </select>
                                </div>

                            </div>

                            <div className='Newfund-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Scheme</th>
                                            <th className='text-left'>Type</th>
                                            <th className='text-right'>Open Date</th>
                                            <th className='text-right'>Close Date</th>
                                            <th className='text-right'>Min Amount(&#8377;)</th>
                                            <th className='text-right'>Offer Price(&#8377;)</th>
                                            <th className='text-left'>Category</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ Sch_Name, TypeName, Launc_Date, CLDATE, OFFERPRICE, MININVT, VClass }) => (
                                                <tr>
                                                    <td className="text-left"><h6 onClick={() => routeChange(Sch_Name)}>{Sch_Name}</h6></td>
                                                    <td className="text-left">{TypeName}</td>
                                                    <td className="text-right">{(Launc_Date != null) ? (format(parseISO(Launc_Date), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-right">{(CLDATE != null) ? (format(parseISO(CLDATE), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-right">{MININVT}</td>
                                                    <td className="text-right">{OFFERPRICE}</td>
                                                    <td className="text-left">{VClass}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Newfundoffer;